const resources = {
  en: {
    translation: {
      'welcome':               'Welcome to CGTrader storybook',
      'where-components-live': 'This is where our components will live',
      'interpolation1':        'this is example of {{dataObject.entry2}} with interpolation using {{dataObject.entry1}} and data object',
      'interpolation2':        'this is example of {{entry2}} with interpolation using {{entry1}} and params'
    },
    product:     {
      vatNotice: 'All prices are exclusive of VAT',
      license: {
        tooltips: {
          editorial_no_ai: `The product can only be used in an editorial manner (educational, non-commercializable<br/>
personal project, in newsworthy and of public interest events) and may not be used for any<br/>
commercial, promotional, or merchandising purposes.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
          royalty_free: `Products under Royalty Free License can be used without liability to pay any license fees for<br/>
multiple lifelong uses, or sales volume of final product after being paid for once. The product<br/>
may not be sold, given, or assigned to another person or entity in the form it is downloaded from the site.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
          royalty_free_no_ai: `Products under Royalty Free License can be used without liability to pay any license fees for<br/>
multiple lifelong uses, or sales volume of final product after being paid for once. The product<br/>
may not be sold, given, or assigned to another person or entity in the form it is downloaded from the site.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
          custom: `Custom License allows uses of the product as specified by designer. Such additional license<br/>
terms shall be applied and interpreted as additions and (or) exceptions to the conditions set<br/>
by general licensing terms and Royalty Free License.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
          custom_no_ai: `Custom License allows uses of the product as specified by designer. Such additional license<br/>
terms shall be applied and interpreted as additions and (or) exceptions to the conditions set<br/>
by general licensing terms and Royalty Free License.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
          editorial_royalty_free: `Products under Royalty Free License can be used without liability to pay any license fees for<br/>
multiple lifelong uses, or sales volume of final product after being paid for once. The product<br/>
may not be sold, given, or assigned to another person or entity in the form it is downloaded from the site.<br/>
<a href='/pages/terms-and-conditions#general-terms-of-licensing' rel='nofollow' target='_blank'>Read more</a>`,
        }
      },
      cldPopover: `
<div class="u-text-center">
  {{discounted}} discount from your remaining {{available}}
  <a href='https://www.cgtrader.com/pages/cgtrader-loyalty-discounts' target='_blank'>CGTrader points</a>. <br>
  The points can be used for up to 30% discount for each purchased model.
</div>`
    },
    enterprise: {
      meta: {
        title: 'Enterprise Solutions - Empowering You Through 3D Content',
        description: `CGTrader offers enterprise 3D solutions for your business: mass production of 3D models,
dedicated 3D asset sourcing and QA, and an extensive stock 3D model database.`
      },
      testimonials: [
        {
          'slug':        'microsoft',
          'title':       'Microsoft',
          'testimonial': 'My experience on CGTrader was fantastic! The models that I purchased were very high ' +
                           'quality, which allowed me to drop them into my project immediately. The customer support ' +
                           'staff at CGTrader was amazing and resolved my issue within a short period of time!.',
          'author':      `<strong>Ed Miller</strong>, XR Design Developer, Microsoft`,
          'imageHeight': 40,
          'link':        'temp-microsoft-link'
        },
        {
          'slug':        'nvidia',
          'title':       'Nvidia',
          'testimonial': 'Purchasing on CGTrader was really simple and straightforward. Select the models you want ' +
                           'to use, checkout, pay and download. It’s that simple.',
          'author':      `<strong>Ruediger Raab</strong>, Graphics Engineer, Nvidia`,
          'imageHeight': 45,
          'link':        'temp-nvidia-link'
        },
        {
          'slug':        'nike',
          'title':       'Nike',
          'testimonial': 'CGTrader is my favorite 3D source because of the range of assets you expose.',
          'author':      `<strong>Jason Crist</strong>, Technology Scout, Nike`,
          'imageHeight': 40,
          'link':        'temp-nike-link'
        },
        {
          'slug':        'eon_reality',
          'title':       'EON Reality',
          'testimonial': 'CGTrader provides industry-leading, quality models for production and naturally we find ' +
                           'them incredibly useful',
          'author':      `<strong>Adam Bladowski</strong>, Trainer & AVR Content Manager, EON Reality`,
          'imageHeight': 50,
          'link':        'temp-petco-link'
        }
      ],
    }
  }
}

export default resources
